import jwtAxios from '@crema/services/auth/jwt-auth/jwt-api';
import { toast } from 'react-toastify';

export const retrieveFreightForwarderAdminListAction = (page = 1, perPage = 20) => {
  return async (dispatch) => {
    try {
      const res = await jwtAxios({
        url: `/superadmin/company/ffadmin-list?page=${page}&size=${perPage}`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      dispatch({
        type: 'ADMINS_LIST',
        payload: [res.data.totalElements, res.data.content],
      });

      return new Promise((resolve, reject) => {
        resolve(res);
      });
    } catch (error) {
      // console.log(error);
      toast.error('Internal Server Error');
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };
};

export const retrieveFreightForwarderAdminsEnrolledAction = (companyId, page, perPage) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        // url: `/superadmin/company/${companyId}`,
        // url : `/superadmin/airline/company/${companyId}`,
        url: `/superadmin/airline/company/${companyId}?page=${page}&size=${perPage}`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      // dispatch({
      //   type: 'ADMINS_ENROLLED',
      //   payload: [...res.data],
      // });
      // const { requesting } = getState().retrieveFreightForwarderAdminList;

      return new Promise((resolve, reject) => {
        resolve(res);
      });

    } catch (error) {
      // console.log(error);
      // toast.error('Internal Server Error');
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };
};

export const deleteAdminAction = (userId) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        method: 'delete',
        url: `/superadmin/company/ffadmin/delete/${userId}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });


      if (res.status >= 200 || res.status <= 300) {
        toast.success('Record Deleted Successfully');
      }
    } catch (err) {
      // console.log(err);
      toast.error('Internal Server Error');
    }
  };
};


export const retrieveFreightForwarderAdminsListRowData = (companyId) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        url: `/superadmin/company/ffadmin/${companyId}`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      dispatch({
        type: 'RETRIEVE_FRIEGHT_FORWARDER_ADMINS_LIST_ROW_DATA',
        payload: res.data,
      });

    } catch (error) {
      // console.log(error);
      toast.error('Internal Server Error');
    }
  };
};

export const updateAdminListRowInFreightForwarder = (DATA) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        url: `/superadmin/company/ffadmin/update`,
        method: 'put',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          ...DATA
        }
      });
      if (200 <= res.status && res.status < 300) {
        toast.success("Record Updated Successfully");
      } else {
        toast.error(`Internal Server Error`);
      }
    } catch (error) {
      // console.log(error);
      toast.error('Internal Server Error');
    }
  };
};

export const saveTermofuse = (DATA) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        url: `/terms-of-use/save`,
        method: 'post',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          ...DATA
        }
      });
      if (200 <= res.status && res.status < 300) {
        toast.success("Terms Saved Successfully");
      } else {
        toast.error(`Internal Server Error`);
      }
    } catch (error) {
      // console.log(error);
      toast.error('Internal Server Error');
    }
  };
};


export const retrieveTermofuse = (role) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        url: `/terms-of-use/${role}`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (res) {
        return new Promise((resolve, reject) => {
          resolve(res)
        })
      }

    } catch (error) {
      // console.log(error);
      toast.error('Internal Server Error');
    }
  };
};


export const saveTruckingconfigurationinsuperadmin = (data) => async (dispatch) => {

  try {
    const res = await jwtAxios({
      url: '/trucking/provider/save',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: data.providers,
    });
    if (res.status >= 200 && res.status <= 300) {
      // dispatch(getUserMailTextMessage());
      toast.success(`${res.data.message}`);

      return new Promise((resolve, reject) => {
        resolve(res);
      })
    }
  } catch (error) {
    toast.error(`${error.response.data.error}`);

    return new Promise((resolve, reject) => {
      reject(error);
    })
  }
};


export const retrieveSuperAdminTruckinglist = () => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        url: `super-admin/trucking/provider/content-list`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (res.status == 200) {
        return new Promise((resolve, reject) => {
          resolve(res)
        })
      }

    } catch (error) {
      // console.log(error);
      toast.error('Internal Server Error');
    }
  };
};


export const deleteSuperAdminTrucking = (tid) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        method: 'delete',
        url: `/trucking/provider/${tid}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });


      if (res.status >= 200 || res.status <= 300) {
        toast.success('Record Deleted Successfully');
        return new Promise((resolve, reject) => {
          resolve(res)
        })
      }
    } catch (err) {
      // console.log(err);
      toast.error('Internal Server Error');
    }
  };
};








export const saveAirrateconfigurationinsuperadmin = (data) => async (dispatch) => {

  try {
    const res = await jwtAxios({
      url: 'super-admin/airrate/provider/save',
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: data.providers,
    });
    if (res.status >= 200 && res.status <= 300) {
      // dispatch(getUserMailTextMessage());
      toast.success(`${res.data.message}`);

      return new Promise((resolve, reject) => {
        resolve(res);
      })
    }
  } catch (error) {
    console.log(error.data, 'error', error.response)
    toast.error(`${error.response.data.error}`);

    return new Promise((resolve, reject) => {
      reject(error);
    })
  }
};


export const retrieveSuperAdminAirrateproviderlist = () => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        url: `super-admin/airrate/provider/list`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (res.status == 200) {
        return new Promise((resolve, reject) => {
          resolve(res)
        })
      }

    } catch (error) {
      // console.log(error);
      toast.error('Internal Server Error');
    }
  };
};


export const deleteSuperAdminAirrate = (tid) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        method: 'delete',
        url: `super-admin/airrate/provider/delete/${tid}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });


      if (res.status >= 200 || res.status <= 300) {
        toast.success('Record Deleted Successfully');
        return new Promise((resolve, reject) => {
          resolve(res)
        })
      }
    } catch (err) {
      // console.log(err);
      toast.error('Internal Server Error');
    }
  };
};

export const publishAnnouncement = (DATA, actionType = 'save') => {
  return async (dispatch, getState) => {

    try {
      const res = await jwtAxios({
        url: `/announcements`,
        method: 'post',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: DATA,
      });
      if (res.status >= 200 && res.status < 300) {
        dispatch(retreiveAnoouncement());
        dispatch(retreiveAnoouncementforall());

        if (actionType === 'publish') {
          toast.success('Announcement published successfully');
        } else if (actionType === 'unpublish') {
          toast.success('Announcement unpublished successfully');
        } else {
          toast.success('Announcement saved successfully');
        }
      } else {
        toast.error('Unable to save announcement');
      }
    } catch (error) {
      // console.log(error);
      toast.error('Internal Server Error');
    }
  };
};

export const retreiveAnoouncement = (role) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        url: `/announcements/latest`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (res?.status == 200) {
        dispatch({ type: 'SAVE_ANNOUNCEMENT', payload: res?.data })
        return new Promise((resolve, reject) => {
          resolve(res)
        })
      }
      if (res?.status == 204) {
        dispatch({ type: 'SAVE_ANNOUNCEMENT', payload: {} })

      }

    } catch (error) {
      // console.log(error);
      toast.error('Internal Server Error');
    }
  };
};

export const retreiveAnoouncementforall = (role) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        url: `/announcements/all`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (res?.status == 200) {
        dispatch({ type: 'SAVE_ANNOUNCEMENT_ALL', payload: res?.data })
        return new Promise((resolve, reject) => {
          resolve(res)
        })
      }
      if (res?.status == 204) {
        dispatch({ type: 'SAVE_ANNOUNCEMENT_ALL', payload: {} })

      }

    } catch (error) {
      // console.log(error);
      toast.error('Internal Server Error');
    }
  };
};


export const dismissAnnouncement = (id) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        method: 'delete',
        url: `/announcements/dismiss?announcementId=${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });


      if (res.status >= 200 || res.status <= 300) {
        dispatch(retreiveAnoouncement())
        dispatch(getAnnouncementByuser())
        dispatch(retreiveAnoouncementforall())
        // toast.success('Announcement dismissed successfully');

        return new Promise((resolve, reject) => {
          resolve(res)
        })
      }
    } catch (err) {
      // console.log(err);
      toast.error('Internal Server Error');
    }
  };
};

export const setAnnouncementHeighttostore = (height) => (dispatch) => {
  dispatch({ type: 'SET_ANNOUNCEMENT_HEIGHT', payload: height })

}

export const deleteAnnouncementFromList = (id) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        method: 'delete',
        url: `/announcements/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });


      if (res.status >= 200 || res.status <= 300) {
        dispatch(retreiveAnoouncementforall())
        toast.success('Announcement deleted successfully');

        return new Promise((resolve, reject) => {
          resolve(res)
        })
      }
    } catch (err) {
      // console.log(err);
      toast.error('Internal Server Error');
    }
  };
};



export const getAnnouncementByuser = (id) => {
  return async (dispatch, getState) => {
    try {
      const res = await jwtAxios({
        method: 'get',
        url: `announcements/latest-by-company`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });


      if (res.status >= 200 || res.status <= 300) {
        dispatch({ type: 'SAVE_USER_ANNOUNCEMENT', payload: res?.data })
        // dispatch(retreiveAnoouncement())
        // dispatch(retreiveAnoouncementforall())
        // toast.success('Announcement dismissed successfully');

        return new Promise((resolve, reject) => {
          resolve(res)
        })
      }
    } catch (err) {
      // console.log(err);
      toast.error('Internal Server Error');
    }
  };
};
